import http from "http";
import https from "https";

export default {
  timeout: 60000,
  httpAgent: new http.Agent({
    keepAlive: true
  }),
  httpsAgent: new https.Agent({
    keepAlive: true
  }),
  maxRedirects: 10,
  maxContentLength: 10 * 1024 * 1024,
  maxBodyLength: 100 * 1024 * 1024 // 100 MB for files
};
